let routesContainer

const initCookieMessage = e => {
    const cookieMessage = document.getElementById('cookie-message')
    if (
        cookieMessage && !(
            localStorage.getItem('bikemap-cookieConsent') || // no dismiss entry
            (window.navigator && window.navigator.CookiesOK) // and no default permission
        )
    ) {
        cookieMessage.classList.add('show')
        document.getElementById('privacy-ok').addEventListener('click', e => {
            e.preventDefault()
            cookieMessage.classList.remove('show')
            localStorage.setItem('bikemap-cookieConsent', JSON.stringify({
                timestamp: Date.now(),
            }))
        })
    }
}

const insertRoutes = json => {
    routesContainer.innerHTML = json.page
    document.body.scrollTop = 0 // For Safari
    document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
    initPagination()
}

const getPage = function (e) {
    const { urlBase, number } = this.dataset
    const url = atob(urlBase) + ((number > 1) ? '?page=' + number : '')

    fetch(url, {
        headers: {
            'x-requested-with': 'XMLHttpRequest',
        },
        credentials: 'same-origin',
    })
        .then(res => res.json())
        .then(insertRoutes)

    history.pushState({}, 'page ' + number, url)
}

const initPagination = () => {
    const buttons = document.querySelectorAll('#pagination .btn:not(:disabled)')
    // Don't use .forEach here as is wouldn't work in IE (buttons is a NodeList object)
    for (let i = 0; i < buttons.length; i++) {
        buttons[i].addEventListener('click', getPage.bind(buttons[i]))
    }
}

const init = e => {
    routesContainer = document.getElementById('routes')

    if (document.cookie.indexOf('outdoorish_logged_in') === -1) {
        document.getElementById('login').classList.remove('hidden')
    }

    initPagination()
    initCookieMessage()
}

document.addEventListener('DOMContentLoaded', init)
